import {gql} from "graphql-tag";
import {baseResponseGraphqlField} from "../../../base.graphql";


export const carouselItemFields = `
id
uniqueId
title
description
image
`;


export const CREATE_CAROUSEL_ITEM_MUTATION = gql`
mutation CreateCarouselSlideMutation($input: CarouselSlideInputObject!) {
  createCarouselSlideMutation(input: $input) {
    ${baseResponseGraphqlField}
    data {
      ${carouselItemFields}
    }
  }
}
`


export const UPDATE_CAROUSEL_ITEM_MUTATION = gql`
mutation UpdateCarouselSlideMutation($input: CarouselSlideInputObject!) {
  updateCarouselSlideMutation(input: $input) {
    ${baseResponseGraphqlField}
    data {
      ${carouselItemFields}
    }
  }
}
`


export const DELETE_CAROUSEL_ITEM_MUTATION = gql`
mutation DeleteCarouselSlideMutation($uniqueId: String!) {
  deleteCarouselSlideMutation(uniqueId: $uniqueId) {
    ${baseResponseGraphqlField}
  }
}
`


export const GET_CAROUSEL_ITEMS = gql`
query GetCarouselSlides($filtering: CarouselSlideFilteringInputObject) {
  getCarouselSlides(filtering: $filtering) {
    ${baseResponseGraphqlField}
    data {
      ${carouselItemFields}
    }
  }
}
`
